import template from "./template_crud";
const accounts = '/accounts'
export const getAccountList = template.getList(accounts)
export const addAccount = template.addOne(accounts)
export const updAccount = template.updById(accounts)
export const setIsDeleteAccount = template.updById(accounts,'/delete')